import React from 'react';
import styled from 'styled-components';
import { StateButton, StateButtonProps } from '~common/components/button/state-button.component';
import { ArrowLeftIcon } from '~web/view/components/ui/icon/arrow-left.icon';

export const ArrowLeftButton: React.FunctionComponent<StateButtonProps> = ({ ...rest }) => (
  <StyledStateButton {...rest}>
    <StyledArrowLeftIcon width={12} height={18} />
  </StyledStateButton>
);

const StyledStateButton = styled(StateButton)`
  && {
    min-width: 54px;
    width: 54px;
    height: 54px;
    padding: 0;
  }
`;

const StyledArrowLeftIcon = styled(ArrowLeftIcon)`
  margin-right: 4px;
`;



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/components/ui/button/arrow-left-button.component.tsx